/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMemo } from 'react';

import { Image } from 'aresui';

import * as storage from 'firebase/storage';
import Skeleton from 'react-loading-skeleton';

import * as Icons from 'icons';
import * as P from 'models/Project';
import Button from 'components/Button';
import { controllers } from 'controllers';
import { storageRef } from 'config/firebase';

import { ProjectContainer } from './styles';

interface ComponentProps {
	project: P.Project;
	isAdmin?: boolean;
}

const DELETE_CONFIRM =
	'Tem certeza que deseja apagar o projeto {{name}}? Esta ação é irreversível.';

function Project(props: ComponentProps) {
	// Memo vars
	const highlighted = useMemo(() => {
		return !!props.project.highlight;
	}, [props.project.highlight]);

	// Functions
	async function handleDelete() {
		const { name, ...project } = props.project;

		const confirmed = confirm(DELETE_CONFIRM.replace('{{name}}', name));
		if (!confirmed) return;

		await controllers.project.delete(project.id);

		await Promise.all(
			project.images.map(({ url }) =>
				storage.deleteObject(storageRef(url))
			)
		);
	}

	async function handleHighlight() {
		await controllers.project.update(props.project.id, {
			highlight: !highlighted,
		});
	}

	function isActive(value: any) {
		return !!value ? 'active' : '';
	}

	return (
		<ProjectContainer className="project">
			<div className="project-image">
				<Image
					src={props.project.images[0].url}
					alt=""
					width={500}
					height={(500 / 4) * 3}
                    quality={100}
				/>
			</div>

			<div className="project-info">
				{props.isAdmin && (
					<div className="actions">
						<div className="action" title="Visualizar">
							<Icons.FiEye />
						</div>

						<div
							className={`action ${isActive(highlighted)}`}
							title="Destacar"
							onClick={handleHighlight}
						>
							<Icons.FiStar />
						</div>

						<div
							className="action"
							title="Apagar"
							onClick={handleDelete}
						>
							<Icons.FiTrash />
						</div>
					</div>
				)}

				<div className="categories">
					{props.project.category.map((value) => (
						<small key={value}>{value}</small>
					))}
				</div>

				<strong>{props.project.name}</strong>

				<p>{props.project.description}</p>

				{!props.isAdmin && (
					<a
						href="#"
						rel="noreferrer noopener"
						target="_blank"
					>
						<Button variant="default">
							Visitar projeto <Icons.FiExternalLink />
						</Button>
					</a>
				)}
			</div>
		</ProjectContainer>
	);
}

function ProjectSkeleton() {
	return (
		<ProjectContainer className="project skeleton">
			<Skeleton />
		</ProjectContainer>
	);
}

Project.Skeleton = ProjectSkeleton;

export default Project;
